import React from "react";
import Header from "../Components/common/Header";
import PartenaireList from "../Components/partenaire/PartenaireList";
import AdmissionList from "../Components/admission/AdmissionList";
import ActualiteList from "../Components/actualite/ActualiteList";
import TemoignageList from "../Components/temoin/TemoignageList";
import Titre from "../Components/common/Titre";
import "flickity/css/flickity.css";
import video from "../assets/video/CISSVideo.mp4";
import { NavLink } from "react-router-dom";
import CommunauteList from "../Components/communaute/CommunauteList";
import pisa from "../assets/img/pisa.png";
import ontario from "../assets/img/LOGO_ACCREDITATION_ONTARIO.png";
export default function Homepage() {
  const flickityOptions = {
    initialIndex: 0,
    cellAlign: "center",
    contain: true,
    pageDots: false,
    freeScroll: false,
    wrapAround: false,
    autoPlay: false,
    prevNextButtons: false,
  };
  const partenaires = [
    {
      id: 1,
      logo: pisa,
    },
    {
      id: 2,
      logo: "https://ipyme.org/es-es/politicasymedidas/ocde/PublishingImages/OECD_logo.svg.png",
    },
    {
      id: 3,
      logo: ontario,
    },
  ];
  return (
    <>
      <Header />

      <div className="mx-auto   bg-white rounded-0">
        <Titre
          children={"NOUS SOMMES ACCREDITES PAR"}
          soustitre={"Restez informés de toutes les nouvelles actualités."}
        />
        <div className="d-flex align-items-center pb-2 pb-md-5 justify-content-center">
          {partenaires.map((partenaire) => (
            <div
              key={partenaire.id}
              className="carousel-cell-section  bg-transparent shadow-none"
            >
              <img
                src={partenaire.logo}
                alt={`Partenaire ${partenaire.id}`}
                className="shadow-none bg-transparent"
              />
            </div>
          ))}
        </div>

        <div>
          <AdmissionList />
        </div>
      </div>

      <div style={{ marginTop: "130px" }}>
        <CommunauteList />
      </div>

      <div>
        <div className="container my-5  border-left ps-4">
          <div className="row align-items-center">
            <div className="col-md-6 mb-2 mb-md-0">
              <h2 className="mb-4 custom-titre-h1 text-left">
                NOTRE PARTENAIRE AGREE PAR LE MINISTERE DE L'EDUCATION DE
                L'ONTARIO
              </h2>
              <p>
                Grâce aux solides partenariats conclus avec les écoles
                autorisées par le ministère de l’Éduca tion de l’Ontario à
                décerner des crédits et le Diplôme d’étude secondaire de
                l’Ontario, Obtiens ton diplôme en bénéficiant de toute la f
                lexibilité dont tu as besoin pour évoluer en toute confiance
                vers tes objectifs, quelle que soit la voie de carrière que tu
                choisis.
              </p>
              <NavLink
                to="/about"
                className="text-decoration-none btn bg-b text-white mt-3"
              >
                Voir Plus
              </NavLink>
            </div>

            <div className="col-md-6">
              <div className="ratio ratio-16x9">
                <video controls>
                  <source src={video} type="video/mp4" />
                  Votre navigateur ne supporte pas la balise vidéo.
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="container " id="actualite">
        <ActualiteList />
      </div>

      <div className="container ">
        <TemoignageList />
        <div id="partenaire" className="mb-5">
          <PartenaireList />
        </div>
      </div>
    </>
  );
}
